import ClientSaveButtons from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/ClientSaveButtons'
import ClientSaveStatus from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/ClientSaveStatus/ClientSaveStatus'
import useClientSaveStatus from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/ClientSaveStatus/useClientSaveStatus'
import { SaveArea } from './styled-components'

interface ClientTabSaveAreaProps {
  hidden: boolean
}

const ClientTabSaveArea = ({ hidden }: ClientTabSaveAreaProps) => {
  const { hasPendingSave } = useClientSaveStatus()

  if (hidden) return null

  return (
    <SaveArea>
      <ClientSaveStatus />
      <ClientSaveButtons hidden={!hasPendingSave} />
    </SaveArea>
  )
}

export default ClientTabSaveArea
